module.exports = __webpack_public_path__ + "img/ajoure.645d772.svg";